import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Avatar,
  TextField,
  Paper,
  Typography,
  Grid,
  Switch
} from '@material-ui/core';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import storage from "../../../../firebaseConfig.js"
import Autocomplete from '@material-ui/lab/Autocomplete';
import { NetworkContext } from '../../../../context/NetworkContext.js';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
    marginTop: theme.spacing(2),
    textAlign: 'left'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'

  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {

    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  input: {
    display: 'none',
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

const BrokerDetails = props => {
  const { open, onClose, onUpdate, usercontent, masters, viewtype, className, isEdit, ...rest } = props;

  const classes = useStyles();
  const [basicInfo, setBasicInfo] = React.useState({});
  const [subcommodity, setSubcommodity] = React.useState([]);
  const [error, setError] = React.useState({});

  const initialValues = {
    languages: ['All', 'Tamil', 'English', 'Telugu'],
    brokers_name: '',
    contact_number: '',
    city: '',
    image: '',
    adsurl: '',
    module: '',
    imageurl: '',
    commodity: [],
    priority: '',
    adtype: '',
    language: [],
    state: {}
  };
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [percent, setPercent] = React.useState(0);

  const [values, setValues] = useState({
    ...initialValues
  });

  const setData = async (value, name, fun, state) => {
    let url = null;
    let extra = {};
    if (name === "image") {
      if (!value) {
        alert("Please choose a file first!")
      }

      const storageRef = ref(storage, `/spot/${value.name}`)
      const uploadTask = uploadBytesResumable(storageRef, value);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          // update progress
          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            console.log("imageurl" + url)
            setValues(values => ({
              ...values,
              ['imageurl']: url
            }));
          });
        }
      );
    }
  }


  React.useEffect(() => {
    if (usercontent && usercontent.languages) {
      setValues({
        ...usercontent
      })
    }
  }, [usercontent]);
  React.useEffect(() => {
    if (usercontent && usercontent.languages) {
      setValues({
        ...usercontent
      })
    }
    if(usercontent.commodity)
    {
      let commodity_ids = [];
       
      commodity_ids.push(usercontent.commodity.id)
      
      fetchsubcommodity(commodity_ids)
    }
  }, [usercontent]);
  const handleSubmit = event => {
    event.preventDefault();
    let errorobj ={}
    let isvalid = true;
    if(!values.commodity || values?.commodity?.length == 0)
    {
      isvalid = false
      errorobj['commodity'] = "Please choose atleast one commodity"
    }

    if(!values.state || values?.commodity?.length == 0)
    {
      isvalid = false
      errorobj['state'] = "Please choose atleast one state"
    }

    if(!values.priority || values?.priority?.length == 0)
    {
      isvalid = false
      errorobj['priority'] = "Please enter priority"
    }

    if(!values.module || values?.module?.length == 0)
    {
      isvalid = false
      errorobj['module'] = "Please enter module"
    }

    if(!values.imageurl || values?.imageurl?.length == 0)
    {
      isvalid = false
      errorobj['imageurl'] = "Please enter image"
    }
    if(!values.adtype || values?.adtype?.length == 0)
    {
      isvalid = false
      errorobj['adtype'] = "Please enter adtype"
    }
    setError({...errorobj})
  
    if(isvalid)
    {
      onUpdate && onUpdate(values);
    }
  // 
  };

  const handleoptionchange = type => (event, value) => {
    if (type == 'commodity') {
      if (value) {
        let commodity_ids = [];
       
        commodity_ids.push(value.id)
        
        fetchsubcommodity(commodity_ids)

      } else {
        setSubcommodity([])
        setValues(values => ({
          ...values,
          [subcommodity]: null
        }));
      }
    }

    if(type == 'state'){
      values.city = ''
    }

    setValues(values => ({
      ...values,
      [type]: value
    }));
  }

  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  async function fetchsubcommodity(commodityID) {
    let bodycontent = {
      commodity: commodityID
    }
    
    let commodity_arr = await sendNetworkRequest('/admin/getsubcommodityforcommodity', {}, bodycontent, false)

    setSubcommodity(commodity_arr.module)
    // setState(stateAndCity)
  }
  return (
    <Paper className={classes.papercontent}>
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >

        <div className={classes.content}>
          <Grid container row xs={12}>

            <Grid container xs={9} spacing={4}>
              {/* <Grid item xs={12}>
                {<Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters?.languages??[]}
                  margin="dense"
                  fullWidth
                  value={values?.language??[]}
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('language')}
                  getOptionLabel={(option) => option?.name}
                  renderInput={(params) => <TextField {...params} label={"Languages"} fullWidth margin="dense" variant="outlined" />}
                />}
              </Grid> */}
              <Grid item xs={12}>
                <Autocomplete
                  id="combo-box-demo"
                  options={masters.commodity}
                  margin="dense"
                  fullWidth
                  isRequired
                  disabled={viewtype == 2 ? true : false}
                  value={values.commodity}
                  onChange={handleoptionchange('commodity')}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} label={"Commodity"} 
                  error={error?.commodity}
                  helperText={error?.commodity}
                  fullWidth margin="dense" variant="outlined" />}
                />
              </Grid>
              {subcommodity && subcommodity.length > 0 &&  <Grid item xs={12}> 
                 
                <Autocomplete
                  options={subcommodity}
                  getOptionLabel={(option) => option.name}

                  // multiple
                  id="combo-box-demo"
                  margin="dense"
                  fullWidth
                  value={values.subcommodity}
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('subcommodity')}
                  renderInput={(params) => <TextField {...params} label={"Sub Commodity"} fullWidth margin="dense" variant="outlined" />}
                />
              
              </Grid>}

              <Grid item xs={12}>
                {masters.state && 
                <Autocomplete
                  options={masters?.state??[]}
                  getOptionLabel={(option) => option.name}
                  id="combo-box-demo"
                  margin="dense"
                  fullWidth
                  value={values?.state??{}}
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('state')}
                  renderInput={(params) => <TextField {...params} label={"State"}
                  error={error?.state}
                  helperText={error?.state}
                  fullWidth margin="dense" variant="outlined" />}
                />}
              </Grid>

              {/* <Grid item xs={12}>
                <Autocomplete
                  options={values?.state?.city??[]}
                  id="combo-box-demo"
                  margin="dense"
                  fullWidth
                  filterSelectedOptions
                  getOptionSelected={(option, value) => option === value}
                  value={values.city}
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('city')}
                  renderInput={(params) => <TextField {...params} label={"City"} fullWidth margin="dense" variant="outlined" />}
                />
              </Grid> */}

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  autoComplete="off"
                  id="vendordeliverydays"
                  name="vendordeliverydays"
                  onChange={handleinputchange('adsurl')}
                  value={values.adsurl}
                  label="Ads Url"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  autoComplete="off"
                  id="vendordeliverydays"
                  name="vendordeliverydays"
                  onChange={handleinputchange('priority')}
                  error={error?.priority}
                  helperText={error?.priority}
                  value={values.priority}
                  label="Priority"
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  options={[
                   
                    "live",
                    "rate",
                    "news",
                    "spot",
                    "future",
                    "homepage"
                  ]}

                  id="combo-box-demo"
                  margin="dense"
                  fullWidth
                  // filterSelectedOptions
                  // getOptionSelected={(option, value) => option === value}
                  value={values.module}
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('module')}
                 
                  renderInput={(params) => <TextField {...params} 
                  error={error?.module}
                  helperText={error?.module}
                  label={"Module Type"} fullWidth margin="dense" variant="outlined" />}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  autoComplete="off"
                  id="vendordeliverydays"
                  name="vendordeliverydays"
                  onChange={handleinputchange('imageurl')}
                  value={values.imageurl}
                  error={error?.imageurl}
                  helperText={error?.imageurl}
                  label="Image Url"
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  options={[
                    "banner",
                    "listing",
                    "detail"
                  ]}

                  id="combo-box-demo"
                  margin="dense"
                  fullWidth
                  // filterSelectedOptions
                  // getOptionSelected={(option, value) => option === value}
                  value={values.adtype}
                  disabled={viewtype == 2 ? true : false}
                  onChange={handleoptionchange('adtype')}
                 
                  renderInput={(params) => <TextField {...params} 
                  error={error?.adtype}
                  helperText={error?.adtype}
                  label={"Ad Type"} fullWidth margin="dense" variant="outlined" />}
                />
              </Grid>
              <Grid item xs={12} alignItems={'left'}>
                <Typography variant="h6">Status</Typography>
                <Switch
                  checked={values?.status??false}
                  color="secondary"
                  edge="start"
                  name="Status"
                  onChange={handleoptionchange('status')}
                />
            </Grid>
            </Grid>
            <Grid container xs={3}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                spacing={2}
                style={{ display: "grid" }}
              >
                <Grid style={{ margin: "auto" }}>
                  <input accept="image/*" className={classes.input} id="icon-button-file" type="file"
                    onChange={e => setData(e.target.files[0], "image", setBasicInfo, basicInfo)}
                  />
                  {values.imageurl ? <label htmlFor="icon-button-file">
                    <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                  </label> : <label htmlFor="icon-button-file">
                    <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                  </label>}
                </Grid>
              </Grid>
            </Grid>
          </Grid>


        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            {isEdit ? "Update" : "Submit"}
          </Button>
        </div>
      </form>
    </Paper>
  );
};

BrokerDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default BrokerDetails;
